// Email Confirmation Status Modal
// Parses URL parameters and shows a Bootstrap-styled modal indicating
// whether email confirmation succeeded or failed.

(function () {
  function parseStatus() {
    const url = new URL(window.location.href);
    const p = url.searchParams;

    // Preferred explicit flag we set in redirectTo
    const explicit = p.get('email-confirmation'); // 'success' | 'failed'

    // Supabase may append error indicators on failure
    const sbError = p.get('error') || p.get('error_code') || p.get('error_description');

    // If explicit is set, start with it; otherwise infer from Supabase params
    let status = explicit ? explicit.toLowerCase() : null;

    // If Supabase indicates an error, treat as failure regardless of explicit flag
    if (sbError) status = 'failed';

    // Only show modal when we have a status
    return status; // 'success' | 'failed' | null
  }

  function showModal(status) {
    const isSuccess = status === 'success';
    const textToShow = isSuccess ? 'Your email address has been confirmed successfully' : 'We were unable to confirm your email address.';
    if (window.AuthUI && window.AuthUI.showMessage) {
      window.AuthUI.showMessage(textToShow, !isSuccess);
    }
    
  }

  function ready(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      setTimeout(fn, 0);
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    const status = parseStatus();
    if (!status) return;
    showModal(status);
  });
})();
